import Row, { RowBetween } from 'components/Row';
import Value from 'components/Value';
import useTokenBalance from 'hooks/useTokenBalance';
import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { TYPE } from 'theme';

interface Props {
    address?: string;
    name: string;
    logo: ReactNode | string;
    value?: number;
    suffix?: string;
}

const StyledRow = styled(RowBetween)`
    height: 52px;
    width: 100%;
    gap: 10px;

    svg {
        width: 40px;
        height: 40px;
        margin-right: 10px;
        flex-shrink: 0;
    }

    div,
    span {
        font-size: 18px;
        font-weight: 500;
    }
`;
export default function TokenInfo({ name, address, logo, value, suffix }: Props) {
    const { balance } = useTokenBalance(address || '');
    const displayValue = value || balance.toNumber();

    return (
        <StyledRow>
            <Row>
                {logo}
                <TYPE.main>{name}</TYPE.main>
            </Row>
            <Value value={displayValue} decimals={2} suffix={suffix} />
        </StyledRow>
    );
}
